/* BECK 777 PDP — Phase 1: size picker (D6 truthful pricing) + gallery switching. No globals; scoped to [data-beck-hero].
   Line rollout: guarded multi-color support — single-color products unaffected (no [data-beck-cswatch] present).
   2026-09-02: on-load colourway sync. The gallery opens on product.media.first, but the buy box opens on
   selected_or_first_available_variant — on a 12-colourway glove those are different photos, so the page
   loaded showing one colourway while the swatch row claimed another. Both viewports are now snapped to the
   selected colourway on load (desktop hero image + rail; mobile carousel slide). */
(function () {
  'use strict';
  var hero = document.querySelector('[data-beck-hero]');

  if (hero) {

  /* Size chips — variant picker */
  var priceEl = hero.querySelector('[data-beck-price]');
  var idInput = hero.querySelector('[data-beck-id]');
  var sizeLabel = hero.querySelector('[data-beck-sizelabel]');
  var cta = hero.querySelector('[data-beck-cta]');
  var chips = hero.querySelectorAll('[data-beck-chip]');
  var lastSize = { v: '' };
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      if (chip.disabled) return;
      chips.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
      chip.classList.add('is-selected');
      chip.setAttribute('aria-checked', 'true');
      lastSize.v = chip.getAttribute('data-size') || chip.textContent.trim();
      if (idInput) idInput.value = chip.getAttribute('data-variant-id');
      if (priceEl && chip.getAttribute('data-price')) priceEl.textContent = chip.getAttribute('data-price');
      if (sizeLabel) sizeLabel.textContent = 'Size — ' + chip.textContent.trim();
      if (cta) cta.disabled = false;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', chip.getAttribute('data-variant-id'));
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* no-op */ }
    });
  });

  /* Multi-color (guarded) */
  var cswatches = hero.querySelectorAll('[data-beck-cswatch]');
  if (cswatches.length) {
    var groups = Array.prototype.slice.call(hero.querySelectorAll('[data-color-group]'));
    var clabel = hero.querySelector('[data-beck-colorlabel]');
    cswatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var val = sw.getAttribute('data-color');
        cswatches.forEach(function (s) { var on = s === sw; s.classList.toggle('is-selected', on); s.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        groups.forEach(function (g) { g.hidden = g.getAttribute('data-color-group') !== val; });
        if (clabel) clabel.textContent = val;
        var g = null;
        for (var i = 0; i < groups.length; i++) { if (!groups[i].hidden) { g = groups[i]; break; } }
        if (!g) return;
        var target = lastSize.v ? g.querySelector('[data-beck-chip][data-size="' + lastSize.v + '"]:not([disabled])') : null;
        if (!target) target = g.querySelector('[data-beck-chip].is-selected:not([disabled])') || g.querySelector('[data-beck-chip]:not([disabled])');
        if (target) target.click();
      });
    });
  }

  /* Gallery — thumbnail switching, 200ms crossfade */
  var heroImg = hero.querySelector('[data-beck-heroimg]');
  var thumbs = hero.querySelectorAll('[data-beck-thumb]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      if (!heroImg || t.classList.contains('is-active')) return;
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
      var src = t.getAttribute('data-src');
      var full = t.getAttribute('data-full');
      heroImg.style.opacity = '0';
      window.setTimeout(function () {
        heroImg.onload = function () { heroImg.style.opacity = '1'; heroImg.onload = null; };
        heroImg.srcset = src + ' 1017w, ' + full + ' 1356w';
        heroImg.src = src;
      }, 100);
    });
  });

  /* On-load colourway sync — desktop hero image + rail highlight.
     No crossfade: this is the initial state, not a user-driven transition. */
  (function () {
    if (!heroImg) return;
    var sel = hero.querySelector('[data-beck-cswatch][aria-pressed="true"][data-src]') ||
              hero.querySelector('[data-beck-cswatch].is-selected[data-src]');
    if (!sel) return;
    var src = sel.getAttribute('data-src');
    var full = sel.getAttribute('data-full') || src;
    if (!src) return;
    var matched = false;
    thumbs.forEach(function (t) {
      var on = t.getAttribute('data-src') === src;
      t.classList.toggle('is-active', on);
      if (on) matched = true;
    });
    if (!matched && thumbs.length) { thumbs[0].classList.remove('is-active'); }
    if (heroImg.getAttribute('src') !== src) {
      heroImg.srcset = src + ' 1017w, ' + full + ' 1356w';
      heroImg.src = src;
    }
  })();

  }

  /* On-load colourway sync — mobile carousel. The mobile hero is a separate section, so this runs
     independently of [data-beck-hero]. Swatches carry data-index (slide position, -1 when unknown). */
  (function () {
    if (!window.matchMedia || !window.matchMedia('(max-width:767px)').matches) return;
    var mh = document.querySelector('.beck777-mh[data-mh]');
    if (!mh) return;
    var sw = mh.querySelector('[data-mh-cswatch][aria-pressed="true"][data-index]');
    if (!sw) return;
    var i = parseInt(sw.getAttribute('data-index'), 10);
    if (!(i > 0)) return;
    var track = document.querySelector('[data-lgvmg-track]');
    if (!track) return;
    var thumbs = document.querySelectorAll('[data-lgvmg-thumb]');
    function snap() {
      var w = track.clientWidth;
      if (!w) return false;
      track.scrollLeft = i * w;
      Array.prototype.forEach.call(thumbs, function (t) {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-index'), 10) === i);
      });
      var img = track.children[i] && track.children[i].querySelector('img');
      if (img) { img.setAttribute('loading', 'eager'); }
      return true;
    }
    if (!snap()) {
      var tries = 0;
      var iv = window.setInterval(function () {
        tries++;
        if (snap() || tries > 20) window.clearInterval(iv);
      }, 100);
    }
  })();
})();
